<script lang="ts">
  // „Frage melden“: Tipp abgeben, Frage wird sofort gesperrt.
  import { reportQuestion } from '../../api/content.ts';
  import { t } from '../../i18n.ts';
  let { qid }: { qid: string } = $props();
  let open = $state(false);
  let sent = $state(false);
  let reason = $state('');
  const reasons = ['wrong', 'unclear', 'outdated', 'other'];
  async function send(r: string) {
    reason = r;
    sent = await reportQuestion(qid, r);
    open = false;
  }
</script>

{#if sent}
  <span class="sent" data-testid="report-sent">{t('report.thanks')}</span>
{:else if open}
  <div class="pick" role="group" aria-label={t('report.title')}>
    {#each reasons as r}<button class="chip" onclick={() => send(r)} data-testid={'report-' + r}>{t('report.reason.' + r)}</button>{/each}
  </div>
{:else}
  <button class="link" onclick={() => (open = true)} data-testid="report-btn">⚑ {t('report.title')}</button>
{/if}

<style>
  .link {
    background: none;
    border: 0;
    color: var(--paper);
    opacity: 0.75;
    text-decoration: underline;
    min-height: 44px;
    font-size: 0.85rem;
    justify-self: start;
  }
  .pick {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
  }
  .chip {
    min-height: 40px;
    padding: 4px 12px;
    border-radius: 99px;
    border: 1px solid var(--panel-edge);
    background: rgba(12, 20, 34, 0.6);
    font-size: 0.85rem;
  }
  .sent {
    font-size: 0.85rem;
    color: var(--amber2);
  }
</style>
